let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("f8xBv"), load("ffEVr"), load("kHOMt"), load("hhss7"), load("jE5XU")]).then(() => parcelRequire('alFtm'));